import { Grid, TextField, Typography, Button, Box } from "@mui/material";
import React, { useState } from "react";
import { baseUrl } from "../../constants";
import useAxios from "../../hooks/useAxios";
import CommandList from "../Importation/CommandList";
import { CommandListEntry } from "../../model/CommandEntry";

const CharacterFinderPage = () => {
  const [input, setInput] = useState("");
  const [axiosInstance] = useAxios();
  const [commands, setCommands] = useState<Array<CommandListEntry>>([]);
  const [totalCount, setTotalCount] = useState(0);

  const getCharacters = async (take: Number) => {
    if (input === "") return;
    var split = input.replaceAll(", ", "\n").split("\n");
    const results = await axiosInstance.post<Array<string>>(
      `${baseUrl}/personnages/diff`,
      {
        characters: [...split],
      }
    );
    console.log(results.data, "OMEGA");
    setCommands(
      results.data.map((x) => ({
        id: x,
        command: `idpersonnage ${x}`,
        lastModified: null,
      }))
    );
    setTotalCount(results.data.length);
  };

  const handleSubmit = async () => {
    await getCharacters(50);
  };

  return (
    <Grid container>
      <Grid size={6}>
        <TextField
          label="Entrez la liste des personnages ici"
          variant="filled"
          fullWidth
          multiline
          value={input}
          onChange={(event) => setInput(event.target.value)}
          minRows={30}
          maxRows={30}
        ></TextField>
      </Grid>
      <Grid size={6} sx={{ borderBottom: "solid thin" }}>
        {commands.length > 0 && (
          <Box>
            <Typography variant="body1" sx={{ margin: "5px" }}>
              Personnages à ajouter
            </Typography>
            <CommandList
              fetch={getCharacters}
              commands={commands}
              totalCount={totalCount}
            />
          </Box>
        )}
      </Grid>
      <Button onClick={handleSubmit}>Soumettre</Button>
    </Grid>
  );
};

export default CharacterFinderPage;
